<template>
  <div class="card card-cascade narrower mt-5">
    <div class="view view-cascade gradient-card-header mdb-color lighten-3">
      <h5 class="mb-0 font-weight-bold">ویرایش کسب و کار</h5>
    </div>

    <div class="card-body card-body-cascade text-center">
      <ValidationObserver v-slot="{ invalid }">
        <div class="row">
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="Telphone"
              rules="required"
            >
              <mdb-input label="تلفن" v-model="company.Telphone" />
            </ValidationProvider>
          </div>

          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="Name"
              rules="required"
            >
              <mdb-input
                label="نام کسب و کار"
                class="rtl"
                v-model="company.Name"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <!--First column-->
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="NationalCode"
              rules="required"
            >
              <mdb-input v-model="company.NationalCode" label="شناسه ملی شرکت" />
            </ValidationProvider>
          </div>
          <!--Second column-->
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="RegistrationNumber"
              rules="required"
            >
              <mdb-input
                v-model="company.RegistrationNumber"
                label="شماره ثبت"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <!--First column-->
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="EconomicalNumber"
              rules="required"
            >
              <mdb-input
                v-model="company.EconomicalNumber"
                label="کد اقتصادی"
              />
            </ValidationProvider>
          </div>
          <!--Second column-->
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="CodePost"
              rules="required"
            >
              <mdb-input v-model="company.CodePost" label="کد پستی" />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <!--First column-->
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="Province"
              rules="required"
            >
              <!-- @getValue="getSelectValue" -->
              <mdb-select
                search
                label="لطفا شهر خودتان را انتخاب کنید"
                :options="getCity"
                searchPlaceholder="جستجو"
                :required="true"
                @change="selectCity"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="City"
              rules="required"
            >
              <mdb-select
                search
                label="لطفا استان خودتان را انتخاب کنید"
                :options="getProvince"
                searchPlaceholder="جستجو"
                :required="true"
                @change="selectProvince"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <!--First column-->
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="Address"
              rules="required"
            >
              <mdb-textarea
                v-model="company.Address"
                class="rtl"
                label="ادرس"
                :rows="3"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              name="Descript"
              rules="required"
            >
              <mdb-textarea
                v-model="company.Descript"
                class="rtl"
                label="درباره کسب و کار"
                :rows="3"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <mdb-file-input
              textFieldTitle="انتخاب لوگو"
              btnColor="primary"
              btnTitle="انتخاب"
              :img="true"
              @getValue="saveLogo"
              v-show="showPanelUpload"
            ></mdb-file-input>
            <mdb-btn
              @click="uploadLogo"
              color="warring"
              rounded
              size="sm"
              v-show="showPanelUpload"
              >بروز رسانی</mdb-btn
            >
          </div>

          <div class="col-md-6">
            <mdb-btn
              v-show="!showPanelUpload"
              @click="showUpload"
              color="info"
              rounded
              size="sm"
              >ویرایش
            </mdb-btn>
            <img :src="logo" class="z-depth-1 mb-3 mx-auto logo" />
          </div>
        </div>

        <div class="row">
          <div
            v-show="message !== null"
            class="alert alert-danger"
            v-html="message"
          ></div>
          <div class="col-md-12 text-center my-4">
            <input
              :disabled="invalid || posting"
              :loading="posting"
              @click="confirmCompany"
              type="submit"
              value="بروز رسانی"
              class="btn btn-info btn-rounded"
            />
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import companyApi from "@/api/companyApi";
import uploadApi from "@/api/uploadApi";

import {
  mdbContainer,
  mdbBtn,
  mdbInput,
  mdbTextarea,
  mdbFileInput,
  mdbSelect,
} from "mdbvue";
import { actionTypes, commitTypes, dbName } from "@/store-types";


import systemApi from "@/api/systemApi";

export default {
  name: "company",
  components: {
    mdbContainer,
    mdbBtn,
    mdbInput,
    mdbTextarea,
    mdbFileInput,
    mdbSelect,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      posting: false,
      message: null,
      showPanelUpload: false,
      file: null,
      Avatar: null,
      FullName: null,
      companies: null,
      province: null,
    };
  },
  methods: {
    showUpload() {
      this.showPanelUpload = true;
    },
    saveLogo(files) {
      this.file = files[0];
      console.log("saveLogoImage");
    },
    uploadLogo() {
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("Id", this.company.CompanyId);

      uploadApi.uploadLogo(formData).then(
        ({ data }) => {
          if (data.Status === 1) {
            this.posting = false;
            this.$toastr.s( "آواتار با موفقیت به‌روزرسانی شد.","پروفایل");
            this.company.Logo = data.Data;
            console.log(data.Data);
            this.$store.dispatch(actionTypes.SAVE_DATA);
          } else {
            this.message = data.Message;
            this.posting = false;
            console.log(data);
            this.$toastr.e( data.Message,"پروفایل");
          }
        },
        (r) => {
          var message = r.response.data.errors;
          this.posting = false;
          this.message = null;

          if (message.hasOwnProperty("file")) {
            this.message = message.CaptchaInputText;
          }

          this.$toastr.e("خطا در بارگذاری. لطفاً فایل مناسب را انتخاب کنید.","پروفایل");
        }
      );

      this.showPanelUpload = false;
    },
    selectProvince(value) {
      if (value == null) return;
      console.log("select Province", value);
      this.company.ProvinceId = value;
    },
    selectCity(value, text) {
      if (value == null) return;
      console.log("select City", value, text);
      this.company.CityId = value;
    },
    selectLogoFile(value, company) {
      console.log(value, company);
    },
    confirmCompany() {
      companyApi.updateCompany(this.company).then(
        ({ data }) => {
          if (data.Status === 1) {
            this.posting = false;
            // this.$store.state.userProfile.Avatar = data.Data;
            this.$toastr.s("پروفایل با موفقیت به‌روزرسانی شد.","پروفایل");
          } else {
            this.message = data.Message;
            this.posting = false;
            this.$toastr.e( data.Message,"پروفایل");
          }
        },
        (r) => {
          var message = r.response.data.errors;
          this.posting = false;
          this.message = null;

          if (message.hasOwnProperty("CaptchaInputText")) {
            this.message = message.CaptchaInputText;
          }

          if (message.hasOwnProperty("BirthDate")) {
            this.message = message.BirthDate;
          }

          if (message.hasOwnProperty("FirstName")) {
            this.message = message.FirstName;
          }

          if (message.hasOwnProperty("LastName")) {
            this.message = message.LastName;
          }

          if (message.hasOwnProperty("CodePostal")) {
            this.message = message.CodePostal;
          }

          if (message.hasOwnProperty("Bio")) {
            this.message = message.Bio;
          }

          if (message.hasOwnProperty("Address")) {
            this.message = message.Address;
          }

          if (message.hasOwnProperty("Organization")) {
            this.message = message.Organization;
          }

          if (message.hasOwnProperty("Phone")) {
            this.message = message.Phone;
          }

          if (message.hasOwnProperty("Side")) {
            this.message = message.Side;
          }
        }
      );
    },
  },
  mounted() {
    this.province = this.$store.state.province;
    if (this.province == null) {
      systemApi.getProvince().then(
        ({ data }) => {
          this.$store.state.province = data;
          this.province = this.$store.state.province;
        },
        (r) => {}
      );
    }
  },
  computed: {
    //ProvinceId
    getProvince: function () {
      if (this.province == null || !this.province)
        return [{ value: 0, text: "درحال بارگذاری" }];
      console.log("getProvince");
      let thisVue = this;
      return this.province.map(function (item) {
        return {
          value: item.ProvinceId,
          text: item.Name,
          selected: thisVue.company.ProvinceId == item.ProvinceId,
        };
      });
    },
    getCity: function () {
      if (this.province == null || !this.province)
        return [{ value: 0, text: "درحال بارگذاری" }];
      console.log("getCity");
      let thisVue = this;
      let province = this.province.find((option) => {
        return option.ProvinceId === thisVue.company.ProvinceId;
      });

      if (province == null) {
        console.log("getCity provinceid : " + thisVue.company.ProvinceId);
        return [];
      }

      return province.Cities.map(function (item) {
        return {
          value: item.CityId,
          text: item.Name,
          selected: thisVue.company.CityId == item.CityId,
        };
      });
    },
    logo: function () {
      return this.$store.state.config.MainDomain + "" + this.company.Logo;
    },
  },
};
</script>
